import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import {
    OneDxDealInformation,
    OneDxDealInformationRequest,
    OneDxQuoteDealInformationRequest
} from '../models/onedx.model';

@Injectable({
    providedIn: 'root'
})
export class OneDxPlatformService {
    // TODO: Replace mock data with actual OneDX API call
    // private readonly httpClient = inject(HttpClient);

    public getDealInformation(_request: OneDxDealInformationRequest): Observable<OneDxDealInformation> {
        // TODO: Replace with actual API call
        // return this.httpClient.get<OneDxDealInformation>(`${environment.apiUrl}/onedx/deal-information`, { params: { ...request } });

        const mockData: OneDxDealInformation = {
            customerInformation: {
                customerName: 'Sample Customer 3452',
                quoteContractNumber: 'Q-45633463',
                soldToAddress: '3126 Main Street, Suite 224, New York, NY 10001',
                shipToAddress: '4093 Industrial Blvd, Building 1, Brooklyn, NY 11201'
            },
            materials: [
                {
                    productLine: 'Atellica CH',
                    description: 'Atellica CH Acetaminophen - Atellica CH - RGT - 4 x 300 Tests',
                    smn: '11097595',
                    kitSizeDescription: '-',
                    kitSize: '3560',
                    annualTestVolume: 2960,
                    inventoryAmt: 100,
                    implementationQuantity: 100,
                    orderQuantity: 100,
                    unitPrice: 100,
                    totalPrice: 296000
                },
                {
                    productLine: 'Atellica IM',
                    description: 'Atellica IM Cystatin C - Atellica IM - RGT - 4 x 300 Tests',
                    smn: '11097596',
                    kitSizeDescription: '-',
                    kitSize: '3560',
                    annualTestVolume: 2960,
                    inventoryAmt: 100,
                    implementationQuantity: 100,
                    orderQuantity: 100,
                    unitPrice: 100,
                    totalPrice: 296000
                },
                {
                    productLine: 'Atellica IM',
                    description: 'Atellica IM D-Dimer - Atellica IM - RGT - 4 x 300 Tests',
                    smn: '11097597',
                    kitSizeDescription: '-',
                    kitSize: '3560',
                    annualTestVolume: 2960,
                    inventoryAmt: 100,
                    implementationQuantity: 100,
                    orderQuantity: 100,
                    unitPrice: 100,
                    totalPrice: 296000
                }
            ]
        };

        return of(mockData).pipe(delay(1500));
    }

    public getDealInformationByQuoteNumber(
        request: OneDxQuoteDealInformationRequest
    ): Observable<OneDxDealInformation> {
        const mockData: OneDxDealInformation = {
            customerInformation: {
                customerName: 'Sample Customer 3452',
                quoteContractNumber: request.quoteNumber,
                soldToAddress: '3126 Main Street, Suite 224, New York, NY 10001',
                shipToAddress: '4093 Industrial Blvd, Building 1, Brooklyn, NY 11201'
            },
            materials: [
                {
                    productLine: 'Atellica CH',
                    description: 'Atellica CH Acetaminophen - Atellica CH - RGT - 4 x 300 Tests',
                    smn: '11097595',
                    kitSizeDescription: '-',
                    kitSize: '3560',
                    annualTestVolume: 2960,
                    inventoryAmt: 100,
                    implementationQuantity: 100,
                    orderQuantity: 100,
                    unitPrice: 100,
                    totalPrice: 296000
                },
                {
                    productLine: 'Atellica IM',
                    description: 'Atellica IM Cystatin C - Atellica IM - RGT - 4 x 300 Tests',
                    smn: '11097596',
                    kitSizeDescription: '-',
                    kitSize: '3560',
                    annualTestVolume: 2960,
                    inventoryAmt: 100,
                    implementationQuantity: 100,
                    orderQuantity: 100,
                    unitPrice: 100,
                    totalPrice: 296000
                },
                {
                    productLine: 'Atellica IM',
                    description: 'Atellica IM D-Dimer - Atellica IM - RGT - 4 x 300 Tests',
                    smn: '11097597',
                    kitSizeDescription: '-',
                    kitSize: '3560',
                    annualTestVolume: 2960,
                    inventoryAmt: 100,
                    implementationQuantity: 100,
                    orderQuantity: 100,
                    unitPrice: 100,
                    totalPrice: 296000
                }
            ]
        };

        return of(mockData).pipe(delay(1500));
    }
}
